import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { ASK_FOR_DETAILS_PARAM_NAME, HISTORY_KEY } from "src/constants/UrlConstants";
import { MAX_HISTORY_ENTRIES, ROUTE_PATHS } from "src/utils/constants";
import { createCookie, getCookie } from "src/utils/cookies";

const EXCLUDED_ROUTES = [ROUTE_PATHS.CHECKOUT, ROUTE_PATHS.ASK_FOR_DETAILS, ROUTE_PATHS.REPORT, ROUTE_PATHS.OFFER_PRICE];
const FAVORITES_PENDING_ACTION_PARAM = "pendingFavoriteAction";

const useNavigationTracker = () => {
  const location = useLocation();

  useEffect(() => {
    const path = location.pathname + location.search;

    const shouldExclude = EXCLUDED_ROUTES.some((route) =>
      path.startsWith(route),
    );

    const searchParams = new URLSearchParams(location.search);
    const hasAskForDetailsParam = searchParams.has(ASK_FOR_DETAILS_PARAM_NAME);
    const hasPendingFavoriteActionParam = searchParams.has(FAVORITES_PENDING_ACTION_PARAM);

    const isPdpAskForDetailsRedirect =
      location.pathname.startsWith(ROUTE_PATHS.PRODUCT_DETAIL) &&
      hasAskForDetailsParam;

    const isPdpFavoritesLoginRedirect =
      location.pathname.startsWith(ROUTE_PATHS.PRODUCT_DETAIL) &&
      hasPendingFavoriteActionParam;

    const isBaseProductsRoute = () => {
      const cleanPath = location.pathname;
      return cleanPath === "/products" || cleanPath === "/products/";
    };

    const isExcluded = shouldExclude || isBaseProductsRoute() || isPdpAskForDetailsRedirect || isPdpFavoritesLoginRedirect;

    if (!isExcluded) {
      
      let stored: string[] = [];
      
      try {
        const raw = getCookie(HISTORY_KEY);
        if (Array.isArray(raw) && raw.length > 0) {
          stored = raw;
        }
      } catch (error) {
        console.warn("Failed to parse navigation history cookie:", error);
        stored = [];
      }

      if (stored.length === 0 || stored[stored.length - 1] !== path) {
        stored.push(path);

        const limitedHistory = stored.length > MAX_HISTORY_ENTRIES
          ? stored.slice(-MAX_HISTORY_ENTRIES)
          : stored;

        createCookie(
          HISTORY_KEY,
          encodeURIComponent(JSON.stringify(limitedHistory)),
          null,
        );

      }
    } 
  }, [location]);
};

export default useNavigationTracker;